module.exports = __webpack_public_path__ + "img/CompScope_Bright_09.71ec2dd0.png";